//-================ IMPORTS FOR GENERAL COMPONENT ================-\\
import { Component, inject, OnInit } from '@angular/core';
import { first } from 'rxjs';
import { UserDataCDMS } from 'src/app/Interfaces/GeneralCDMS/User/User.interface';

//-================ IMPORTS FOR SERVICES ================-\\

//-================ IMPORTS FOR CONSTANTS ================-\\

//-================ IMPORTS FOR DEPENDENCIES ================-\\

//-================ IMPORTS FOR INTERFACES ================-\\
import { Group_Reports, Reports } from 'src/app/Interfaces/Interfaces-Global/Reports.interface';
import { UserDataService } from 'src/app/Services/Authentication/User/user-data.service';
import { GeneralRoleCDMS, typeRoleCDMS, typeSystemRoleCDMS } from 'src/app/types/General/RoleCDMS.type';
import { LibraryMasterService } from 'src/app/Services/Libraries/Library-Master/library-master.service';
import { firstValueFrom } from 'rxjs';
import { Response_FIN } from 'src/app/Interfaces/Libraries/Library-FIN-int/Response_FIN.interface';

@Component({
    selector: 'app-all-reports-general',
    templateUrl: './all-reports-general.component.html',
    styleUrls: ['./all-reports-general.component.scss', '../../../Styles/GlobalStyles.css'],
    standalone: false
})
export class AllReportsGeneralComponent implements OnInit {

  //+================== VARIABLE ROLES GENERAL ==================+\\
  public RolesGeneral: typeSystemRoleCDMS = GeneralRoleCDMS;

  //+================== VARIABLES FOR OPTION CARDS REPORTS ==================+\\
  public AllReports: Group_Reports[] = []
  public AllReportsCopy: Group_Reports[] = [
    {
      Title: 'Processes',
      NotRelated: [],
      Roles: [
        this.RolesGeneral.SuperAdministrator,
        this.RolesGeneral.AdministratorFIN,
        this.RolesGeneral.AdministratorSEC,
        this.RolesGeneral.AdministratorIT,
        this.RolesGeneral.ReportsFIN,
        this.RolesGeneral.ReportsSEC,
        this.RolesGeneral.ReportsIT],
      Library: [
        {
          Library: 'Processes',
          Description: 'puede consultar el reporte estructurado de Processes.',
          RouteLink: '/Dashboard/FIN/StructuredReports',
          Roles: [this.RolesGeneral.SuperAdministrator, this.RolesGeneral.AdministratorFIN, this.RolesGeneral.ReportsFIN]
        },
      ]
    }
  ]

  //-========================= SERVICES =========================-\\

  public UserService = inject(UserDataService);
  private MasterLibraryService = inject(LibraryMasterService);
  constructor() { }

  async ngOnInit(): Promise<void> {
    await this.LoadDynamicReportLibraries();
    await this.fillTemplateReports()
  }

  private async LoadDynamicReportLibraries(): Promise<void> {
    try {
      const res: Response_FIN = await firstValueFrom(this.MasterLibraryService.Get_Active_Libraries());
      if (!res.success) {
        return;
      }

      const staticSlugs = ['processes', 'fin'];

      for (const lib of res.operation || []) {
        const slug = String(lib?.Slug || '').toLowerCase();
        const slugUpper = String(lib?.Slug || '').toUpperCase();
        const libName = String(lib?.Nombre || slugUpper);

        if (!slug || staticSlugs.includes(slug)) {
          continue;
        }

        const administratorRole = `Administrator${slugUpper}` as typeRoleCDMS;
        const reportRole = `Reports${slugUpper}` as typeRoleCDMS;

        // Verificar que no exista ya un grupo para esta librería
        const existsGroup = this.AllReportsCopy.some(g =>
          g.Library.some((item: Reports) => item.RouteLink === `/DashboardAdmin/contrTotal/${slug}`)
        );

        if (!existsGroup) {
          // Cada librería dinámica tiene su propio grupo con su propio título
          this.AllReportsCopy.push({
            Title: libName,
            NotRelated: [],
            Roles: [administratorRole, reportRole],
            Library: [
              {
                Library: libName,
                Description: `puede consultar el reporte estructurado de ${libName}.`,
                RouteLink: `/Dashboard/Lib/${slug}/StructuredReports`,
                Roles: [this.RolesGeneral.SuperAdministrator, administratorRole, reportRole]
              }
            ]
          });
        }
      }
    } catch (e) {
      console.error('Error loading dynamic report libraries', e);
    }
  }

  //&===================== FUNCTIONS FOR LOAD COMPONENT =====================&\\

  private async fillTemplateReports(): Promise<void> {

    this.UserService.GetDataUser.pipe(first(value => value.ID !== 0)).subscribe((userData: UserDataCDMS) => {

      const userRoles: typeRoleCDMS[] = userData.Role;

      for (const library of this.AllReportsCopy) {
        const relatedrole = this.getRelatedRoles(library.Roles, userRoles)

        if (relatedrole.length > 0) {
          const tempLibrary: Group_Reports = {
            Title: library.Title,
            Roles: library.Roles,
            NotRelated: [],
            Library: []
          }

          for (const recycle of library.Library) {
            const isRelateLibrary = userRoles.some((item: typeRoleCDMS) => recycle.Roles.some((role: typeRoleCDMS) => item === role))
            isRelateLibrary ? tempLibrary.Library.push(recycle) : tempLibrary.NotRelated.push(0)
          }

          this.AllReports.push(tempLibrary)
        }
      }
    });

  }

  private getRelatedRoles(libraryRoles: typeRoleCDMS[], userRoles: typeRoleCDMS[]): typeRoleCDMS[] {
    return libraryRoles.filter(libraryRole => userRoles.some(userRole => libraryRole === userRole));
  }

  //&===================== END FUNCTIONS FOR LOAD COMPONENT =====================&\\


  //&===================== FUNCTIONS FOR GENERAL COMPONENT =====================&\\

  //-================== FUNCTTION FOR GREETTING ==================-\\

  public GetGreeting(): string {

    let TextGTings: string = '';

    const Date_User = new Date();
    const Hour = Date_User.getHours();

    if (Hour >= 0 && Hour <= 5) {
      TextGTings = 'Buenas noches';
    } else if (Hour >= 6 && Hour <= 11) {
      TextGTings = 'Buenos días';
    } else if (Hour >= 12 && Hour <= 17) {
      TextGTings = 'Buenas tardes';
    } else if (Hour >= 18) {
      TextGTings = 'Buenas noches';
    }

    return TextGTings;
  }

  //-================ FUNCTION FOR NAME USER ================-\\
  public NameUser(): string {
    const Name_User: string = localStorage.getItem('Name_User') || "";
    return (Name_User.split(' ', 2)).join(' ');
  }

  //&===================== END FUNCTIONS FOR GENERAL COMPONENT =====================&\\
}
